
import { AsyncTaskStatus } from '@/types/catalogs/AsyncTask'
import Vue from 'vue'

export default Vue.extend({
  props: {
    status: {
      type: String,
      default: 'NEW'
    },
    title: {
      type: String,
      default: 'Tareas'
    },
    show: {
      type: Boolean,
      default: false
    },
    clearSection: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sectionClass (): String {
      return `notification-section__list--${this.status}`
    },
    sectionClearTitle (): String {
      let title = 'Borrar todas las notificaciones: '
      if (this.status === AsyncTaskStatus.NEW) {
        title += 'nuevas'
      } else if (this.status === AsyncTaskStatus.PROCESSING) {
        title += 'en proceso'
      } else if (this.status === AsyncTaskStatus.DONE) {
        title += 'finalizadas'
      } else if (this.status === AsyncTaskStatus.ERROR) {
        title += 'con error'
      } else if (this.status === AsyncTaskStatus.WAITING) {
        title += 'en espera'
      } else if (this.status === AsyncTaskStatus.CANCELED) {
        title += 'canceladas'
      }
      return title
    }
  },
  methods: {
    clearNotificationsList (): void {
      this.$emit('clear-notifications', this.status)
    }
  }
})
